import { Component, OnInit, OnDestroy } from '@angular/core';
import { RuleDialogService } from '../../../../shared/components/modify-rule/rule-dialog.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-new-model',
  templateUrl: './new-model.component.html',
  styleUrl: './new-model.component.scss',
  standalone: false,
})
export class NewModelComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private dialogRef?: DynamicDialogRef | null;

  constructor(private ruleDialogService: RuleDialogService) {}

  ngOnInit(): void {
    // Any initialization logic
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  openCreateDialog(): void {
    this.dialogRef = this.ruleDialogService.openCreateRuleDialog(true);
  }

  openSimpleCreateDialog(): void {
    this.dialogRef = this.ruleDialogService.openSimpleCreateRuleDialog();
  }
}
